import { useContext } from "react";
import { Stack, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import { RecordContext } from "../../components/record/Record";
import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { useRecord } from "../../api/useRecord";
import { UseRecordsOptions } from "../../api/useRecords";
import { parseClinicNfbCapacity } from "./clinicNfbCapacityParser";
import { ClinicNfbCapacityPresenter } from "./ClinicNfbCapacityPresenter";

export const ClinicNfbCapacityHeader = () => {
    const recordContext = useContext(RecordContext);
    const clinicFromForm = useWatch({ control: recordContext?.entityForm.control, name: "clinic" });
    const selectedClinic = recordContext?.type === "detail" ? recordContext.item?.clinic : clinicFromForm;
    const selectedClinicId = selectedClinic?.id ?? null;

    const clinicQueryOptions = { enabled: Boolean(selectedClinicId) } as UseRecordsOptions;
    const { data: clinicRecord } = useRecord("clinics", "name,settings", selectedClinicId, clinicQueryOptions);
    const nfbCapacity = parseClinicNfbCapacity(clinicRecord?.item?.settings);
    const collectionTitle = recordContext?.collection?.meta.translations?.[0]?.singular;

    return (
        <DetailHeader collection={recordContext?.collection}>
            <Stack direction="row" spacing={4} alignItems="center" justifyContent="space-between" flexWrap="wrap">
                <Typography variant="h4">{collectionTitle}</Typography>
                {nfbCapacity ? <ClinicNfbCapacityPresenter clinicName={clinicRecord?.item?.name} nfbCapacity={nfbCapacity} /> : null}
            </Stack>
        </DetailHeader>
    );
};
